import { WarningIcon } from 'components/shared/PriceNext';
import { FormattedMessage } from 'react-intl';

const RejectedStatus = ({ hasBackendMessage }: { hasBackendMessage: boolean }) => (
  <div className="d-flex align-items-center gap-2 text-danger h-100 px-3 flex-grow-1">
    <span className="quote-ico icon">block</span>
    <span className="flex-grow-1">
      <FormattedMessage id="secondary-market-batch-grid.operation.status.rejected" />
    </span>
    {hasBackendMessage && WarningIcon}
  </div>
);

export default RejectedStatus;
